import { z } from 'zod'

export const evidenceSessionEvidenceSchema = z.object({
  id: z.string(),
})

export type EvidenceSessionEvidence = z.infer<typeof evidenceSessionEvidenceSchema>
